export default __webpack_public_path__ + "static/media/carouselSix.60aea0ce.png";